import { Close12 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IProps {
  onClick(): void;
}

export function Close({ onClick }: IProps) {
  return (
    <div className={styles['container']} onClick={onClick}>
      <Close12 />
    </div>
  );
}
